import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const geometricBackgroundInstances = []; // stored timelines
const SEGMENT_LENGTH = 0.3; // 0-1 fraction of path length
const DURATION_DRAW = 5;
const DURATION_GLOW = 5;

function InitBackgroundGeometry( container ) {
    // console.log("InitBackgroundGeometry", { container, gsap, ScrollTrigger } );
    setupInstance(container);
}

function setupInstance(container) {
    const svg = container.querySelector(".SacredGeometry--svg");
    if (!svg) return;
    const basePaths = Array.from(svg.querySelectorAll(".GeometryLine"));
    if (!basePaths.length) return;

    const glowPaths = [];

    basePaths.forEach((path) => {
        const _length = path.getTotalLength();
        // console.log("basePaths.forEach", { path, _length });

        // segment of the path that will be glowing at once
        const _segment = _length * SEGMENT_LENGTH;

        path.style.strokeDasharray = _length;
        path.style.strokeDashoffset = _length;

        const glowPath = path.cloneNode(true);
        glowPath.classList.add("GeometryLine--glow");

        glowPath.style.strokeDasharray = `${ _segment } ${ _length }`;
        glowPath.style.strokeDashoffset = 0;
        glowPath.style.opacity = 0;

        path.parentNode.appendChild(glowPath);
        glowPaths.push(glowPath);
    });

    // GSAP
    const _timeline = gsap.timeline({
        scrollTrigger: {
            trigger: container,
            start: "top 80%",
            // end: "top -10%",
            // scrub: 1.5,
            scrub: false,
            toggleActions: "play none none none",
        },
        defaults: { ease: "power2.out" }
    });

    // 1. draw lines
    _timeline.to(basePaths, {
        strokeDashoffset: 0,
        duration: DURATION_DRAW,
        stagger: { each: 0.08, from: "start" }
    });

    // 2. trace with glow
    _timeline.to(
        glowPaths,
        {
            strokeDashoffset: (index, glow) => {
                const _length = glow.getTotalLength();
                // const _segment = _length * 0.05;
                const _segment = _length * 0;
                return -(_length - _segment);
            },
            opacity: 1,
            duration: DURATION_GLOW,
            ease: "none",
            stagger: { each: 0.2, from: "start" }
        },
        // "-=0.5"
        "<+0.2"
    );

    // 3. fade out
    _timeline.to(glowPaths, {
        opacity: 0.0,
        duration: 0.3,
        ease: "power1.out"
    });

    // store in `geometricBackgroundInstances`
    geometricBackgroundInstances.push({
        container,
        basePaths,
        glowPaths,
        timeline: _timeline
    });

    // console.log( "setupInstance complete", { geometricBackgroundInstances, timeline: _timeline } );
}


export { InitBackgroundGeometry };